// Centralised place to read env-driven URLs so the rest of the app does not reach into
// import.meta.env directly. Defaults are the production values — overrideable per
// environment via VITE_* envvars in .env / .env.prod / .env.local.

export const GITHUB_APP_INSTALL_URL: string =
  import.meta.env.VITE_GITHUB_APP_INSTALL_URL ??
  'https://github.com/apps/insightpm/installations/new';
